/*
**  rui-banner-notification.js
**
**  rui-banner-notification component
*/
import { LitElement, html, css } from 'lit-element';
import { classMap } from 'lit-html/directives/class-map';
export class RuiBannerNotification extends LitElement {
    static get is() {
        return 'rui-banner-notification';
    }
    static get properties() {
        return {
            type: { type: String },
            isVisible: { type: Object }
        };
    }
    constructor() {
        super();
        this.type = 'information';
        this._isVisible = false;
    }
    // Custom setter for isVisible property
    set isVisible(newValue) {
        if (this._isVisible !== newValue) {
            // Store new value
            this._isVisible = newValue;
            this.requestUpdate();
            // Fire is visible change event
            Promise.resolve().then(() => {
                let isVisibleChangeEvent = new CustomEvent('rui-banner-notification-is-visible-change', {
                    detail: newValue,
                    bubbles: true,
                    composed: true
                });
                this.dispatchEvent(isVisibleChangeEvent);
            });
        }
    }
    // Custom getter for isVisible property
    get isVisible() {
        return this._isVisible;
    }
    hideBannerNotification() {
        this.isVisible = false;
    }
    render() {
        const classes = {
            ['rui-banner-notification']: true,
            ['rui-is-visible']: this._isVisible
        };
        return html `
            <div class="${classMap(classes)}">
                <rui-status-icon type="${this.type}" size="18px" class="rui-banner-notification-icon"></rui-status-icon>
                <div class="rui-banner-notification-content">
                    <slot></slot>
                </div>
                ${this._isVisible ?
            html `<button type="button" class="rui-banner-notification-close-btn" aria-label="Close" @click="${this.hideBannerNotification}"><span aria-hidden="true">&times;</span></button>
                    ` : ''}
            </div>
        `;
    }
    static get styles() {
        return css `
            .rui-banner-notification {
                align-items: center;
                background-color: var(--toast-bg, #222);
                border: none;
                color: var(--toast-fg, #fff);
                display: flex;
                font-size: 14px;
                left: 0;
                margin: 0;
                padding: 10px 10px 11px 10px;
                position: fixed;
                transform: translateY(-100%);
                transition: transform .25s ease-in-out;
                right: 0;
                top: 0;
                user-select: none;
                z-index: 5000;
                -webkit-font-smoothing: antialiased;
            }
            
            .rui-banner-notification.rui-is-visible {
                box-shadow: 0px 1px 2px rgba(0, 0, 0, .2);
                transform: translateY(0);
            }
                        
            @media print {
                .rui-banner-notification {
                    display: none;
                }
            }

            .rui-banner-notification-icon {
                flex: 0 0 auto;
                margin: 6px 10px 0 0;
            }
            
            .rui-banner-notification-content {
                flex: 1 0 0%;
                padding: 5px 10px 5px 0;
                user-select: text;
            }
            
            .rui-banner-notification-close-btn {
                background-color: transparent;
                border: none;
                box-shadow: none;
                color: var(--toast-fg, #fff);
                cursor: pointer;
                flex: 0 0 auto;
                font-size: 24px;
                margin: 0;
                outline-style: none;
                opacity: .75;
                padding: 0;
            }

            .rui-banner-notification-close-btn:focus {
                outline: 1px solid var(--toast-fg, #fff);
                outline-offset: 0;
            }
            
            @media (prefers-reduced-motion: reduce) {
                .rui-banner-notification {
                    transition: none;
                }
            }
            
            @media print {
            
                .rui-banner-notification.rui-is-visible {
                    box-shadow: none;
                    color: var(--text-regular, #181830);
                }
            
                .rui-banner-notification-close-btn {
                    display: none;
                }
            
            }
        `;
    }
}
customElements.get(RuiBannerNotification.is) || customElements.define(RuiBannerNotification.is, RuiBannerNotification);
